import React from 'react'
import './Dashboard.css'
import { Sidebar } from '../../components/Sidebar/Sidebar'
import DataTable from 'react-data-table-component'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'
import { Link } from 'react-router-dom'
import { useState } from 'react'
import axios from 'axios'
import { Baseurl } from '../../../Config/Baseurl'
import { useEffect } from 'react'
import moment from 'moment'

export const Dashboard = () => {
  const [data, setData] = useState([])

  // fetch data of students who have completed their exams(exam history)
  const getData = async () => {
    await axios
      .get(Baseurl.nodeLocal + 'auth/fetchExamGivenStudents')
      .then((res) => {
        setData(res.data.data)
      })
      .catch((err) => {})
  }

  useEffect(() => {
    getData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  // columns to display data in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      selector: (row) => {
        return (
          <Tippy content={row.name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.name}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },
    {
      name: 'Designation',
      selector: (row) => {
        return (
          <Tippy content={row.applied_for} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.applied_for}
            </p>
          </Tippy>
        )
      },
      width: '130px',
    },

    {
      name: 'College',
      selector: (row) => {
        return (
          <Tippy content={row.institute} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.institute}
            </p>
          </Tippy>
        )
      },
    },

    {
      name: 'Exam Title',
      selector: (row) => {
        return (
          <Tippy content={row.exam_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.exam_name}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Attended Date',
      selector: (row) => {
        return (
          <Tippy content={row.exam_given_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {moment(row.exam_given_date).format('DD-MM-YYYY')}
            </p>
          </Tippy>
        )
      },
    },
    {
      name: 'Score',
      selector: (row) => row.correct_ans,
      width: '80px',
    },

    {
      name: 'Action',
      cell: (row) => (
        <>
          <Link to={`/exam-history/${row.id}/${row.exam_id}`} className="link">
            <button className="btn btn-outline-primary btn-sm">
              View Details
            </button>
          </Link>
        </>
      ),
    },
  ]

  return (
    <div className="row">
      <div className="col-md-2">
        <Sidebar />
      </div>
      <div className="mt-4 p-2 col-md-9 mx-5">
        <span className="title text-start">Welcome Back!</span>

        <div className="examHistory mt-5">
          <h5 className="mb-5">Exam History</h5>
          {/* data table */}
          <DataTable
            columns={columns}
            data={data}
            pagination
            highlightOnHover
          />
        </div>
      </div>
    </div>
  )
}
